import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { Form, Input, Tooltip } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  text: string;
  className?: string;
  multiline?: boolean;
  disableUnderline?: boolean;
  fullWidth?: boolean;
  label?: string;
  id?: string;
  disabled?: boolean;
  hideInput?: boolean;
  onCopy?(text: string, result: boolean): void;
}

type CopyButtonProps = {
  text: string;
  disabled?: boolean;
  fallback?(text: string, result: boolean): void;
};

function CopyButton({ text, disabled, fallback }: CopyButtonProps) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipText, setTooltipText] = useState('Copiar');

  const handleTooltipClose = () => setTooltipOpen(false);
  const handleTooltipOpen = () => setTooltipOpen(true);

  const handleCopy = (copiedText: string, result: boolean) => {
    handleTooltipOpen();
    setTooltipText('Copiado');

    if (fallback) {
      fallback(copiedText, result);
    }

    setTimeout(() => {
      handleTooltipClose();
      setTooltipText('Copiar');
    }, 3000);
  };

  return (
    <Tooltip title={tooltipText} open={tooltipOpen} placement='top'>
      <span
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}
        className={
          disabled
            ? 'border-outline-default ml-2 inline-flex cursor-not-allowed items-center border-l pl-2 opacity-50'
            : 'border-outline-default ml-2 inline-flex cursor-pointer items-center border-l pl-2'
        }
      >
        <CopyToClipboard text={text} onCopy={handleCopy}>
          <Icon.Copy />
        </CopyToClipboard>
      </span>
    </Tooltip>
  );
}

const CustomCopyToClipboard: React.FC<IProps> = ({
  text,
  className,
  multiline,
  fullWidth,
  label,
  id,
  disabled,
  hideInput,
  onCopy
}) => {
  if (hideInput) {
    return (
      <div id={id} className={['relative flex items-center gap-2 py-2', className].filter(Boolean).join(' ')}>
        {label ? <small>{label}</small> : ''}
        {text}
        <CopyButton text={text} fallback={onCopy} />
      </div>
    );
  }

  return (
    <div id={id} className={[fullWidth ? 'w-full' : undefined, className].filter(Boolean).join(' ') || undefined}>
      <Form.Item label={label} className='mb-0'>
        {multiline ? (
          <Input.TextArea
            value={text}
            readOnly
            disabled={disabled}
            className={fullWidth ? 'w-full' : undefined}
            autoSize={{ minRows: 2 }}
          />
        ) : (
          <Input
            value={text}
            readOnly
            disabled={disabled}
            suffix={<CopyButton text={text} disabled={disabled} fallback={onCopy} />}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default CustomCopyToClipboard;
